import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesScreenSchemesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-screen-schemes-delete',
	path: '/secure/admin/ViewDeleteIssueTypeScreenScheme.jspa',
};
